import React, { FC, useCallback } from 'react'
import { useReactiveVar } from '@apollo/client'

import { activeProjectVar } from 'modulesCommon/store'
import { useUpdateProject, useUpdateProjectTeamInfo } from 'modulesCommon/graphql/mutations'
import { EditorTextBlock } from 'components'
import { getFieldTitle } from 'modules/Projects/utils'
import { useLocalProjectFlags } from 'modulesCommon/serviceHooks'

const ProjectInfoContainer: FC = () => {
  const activeProject = useReactiveVar(activeProjectVar)
  const { isLocalized } = useLocalProjectFlags(activeProject)

  const { mutate: updateProject } = useUpdateProject()
  const { mutate: updateProjectTeamInfo } = useUpdateProjectTeamInfo()

  const updateProjectInfo = useCallback(
    (data: any) =>
      updateProject({
        variables: {
          input: {
            id: activeProject.id,
            ...data
          }
        }
      }).then(() => {
        activeProjectVar({
          ...activeProject,
          ...data
        })
      }),
    [activeProject, updateProject]
  )

  const updateTeamInfo = useCallback(
    (data: any) =>
      updateProjectTeamInfo({
        variables: {
          input: {
            id: activeProject.id,
            team_info: data.team_info
          }
        }
      }).then(() => {
        activeProjectVar({
          ...activeProject,
          ...data
        })
      }),
    [activeProject, updateProjectTeamInfo]
  )
  const isGlobal = !activeProject.label_id

  return (
    <>
      <EditorTextBlock
        info={activeProject.team_info}
        isActive={activeProject.active}
        onUpdateInfo={updateTeamInfo}
        title={getFieldTitle('team_info', isGlobal)}
        isProject
        isLocalized={isLocalized}
        field="team_info"
        dataTest="project_edit-team_info"
      />
      <EditorTextBlock
        info={activeProject.info}
        isActive={activeProject.active && activeProject.editable}
        onUpdateInfo={updateProjectInfo}
        title={getFieldTitle('info', isGlobal)}
        isProject
        isLocalized={isLocalized}
        field="info"
        dataTest="project_edit-project_info"
      />
    </>
  )
}

export default ProjectInfoContainer
